<script lang="ts">

    export let icon: string;
    export let text: string;
    export let id: string;

</script>

<style lang="scss">

    @use '../variables';

    button {
        border: none;
        background-color: #fff;
        border-radius: 1000rem;
        display: flex;
        align-items: center;
        color: variables.$answer-win-color;
        padding: 0.5rem;
        margin: .5rem;
        font-size: calc(1.2vh + 1.2vw);
        gap: 0.5rem;
        font-family: var(--font-londrina);
        width: calc(100% - 2rem);
        justify-content: center;

        img {
            width: 3vw;
            height: 3vh;
        }

        @media screen and (max-width: 768px) {
            font-size: calc(2vh + 2vw);

            img {
                width: 7vw;
                height: 7vh;
            }
        }

        @media screen and (max-width: 900px) {
            font-size: calc(1.7vh + 1.7vw);

            img {
                width: 5vw;
                height: 5vh;
            }
        }
    }

</style>

<button class="shadow" type="button" on:click id={id}>
    <!-- svelte-ignore a11y-missing-attribute -->
    <img src={icon} /> {text}
</button>

